import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { DashboardLayout } from "../../../components/organisms/Layout";
import Table from "../../../components/atoms/Tables/Table";
import IconSelector from "../../../components/atoms/Selector/IconSelector";
import { addIcon } from "../../../assets/images";
import Certification from "../../../api/Certification";

const Certifications = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [certifications, setCertifications] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    document.title = "HeyHire Portal-Certifications";
    loadCertifications();
  }, []);

  const loadCertifications = () => {
    setLoading(true);
    Certification.getAll()
      .then((response) => setCertifications(response.data.data))
      .catch((error) => {
        if (error?.response?.status !== 403) {
          toast.error(t("common.something-went-wrong"));
        }
      })
      .finally(() => setLoading(false));
  };

  const deleteCertification = (id) => {
    Certification.deleteById(id)
      .then(() => {
        const dataCopy = certifications.slice();
        dataCopy.splice(
          certifications.findIndex((item) => item?.id === id),
          1
        );
        setCertifications(dataCopy);
        toast.success(t("Certification Deleted Successfully"));
      })
      .catch((error) => {
        if (error?.response?.status !== 403) {
          toast.error(t("common.something-went-wrong"));
        }
      });
  };

  return (
    <DashboardLayout darmo={true}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <Table
          isLoading={loading}
          mainHeader={t("certifications.certifications")}
          headers={["Name", "Category", t("common.status"), t("common.action")]}
          data={certifications?.map((cert, index) => (
            <tr
              key={index}
              className="hover:bg-gray-50 transition-colors duration-150"
            >
              <td className="whitespace-nowrap px-6 py-4 text-sm">
                <div className="text-gray-900 font-semibold">
                  {cert.name}
                </div>
              </td>
              <td className="whitespace-nowrap px-6 py-4 text-sm">
                <div className="text-gray-700">
                  {cert?.category?.[0]?.name || "-"}
                </div>
              </td>
              <td className="whitespace-nowrap px-2 sm:px-3 py-2.5 sm:py-3 text-sm md:text-base">
                <span className="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-sm font-medium text-green-700 ring-1 ring-inset ring-green-600/20">
                  Active
                </span>
              </td>
              <td className="whitespace-nowrap px-2 sm:px-3 py-2.5 sm:py-3 text-sm md:text-base">
                <IconSelector
                  menus={[
                    {
                      label: t("common.delete"),
                      action: () => deleteCertification(cert?.id),
                    },
                  ]}
                />
              </td>
            </tr>
          ))}
          emptyState={
            !loading &&
            certifications?.length === 0 && (
              <div className="text-center py-12">
                <svg
                  className="mx-auto h-12 w-12 text-gray-400"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M9 13h6m-3-3v6m-9 1V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
                  />
                </svg>
                <h3 className="mt-2 text-sm font-medium text-gray-900">
                  No certifications found
                </h3>
              </div>
            )
          }
          buttonData={
            <button
              onClick={() => navigate("/admin/certifications/add")}
              className="w-full sm:w-auto flex-shrink-0 cursor-pointer flex justify-center items-center rounded-lg bg-primary-500 px-6 h-10 text-sm font-semibold text-white shadow-sm hover:bg-primary-400 transition-all duration-200"
            >
              <img src={addIcon} alt="add" className="mr-2 w-4 h-4" />
              Add Certification
            </button>
          }
        />
      </div>
    </DashboardLayout>
  );
};

export default Certifications;
